export default "__VITE_ASSET__b7601b37__"